<template>
  <DashboardPanelTemplate
  :panelSize="panelSize"
  :panelFocus="panelFocus"
  :loading="loading || initialRequestLoading"
  :error="loadingError"
  :errorMessage="$t('ErrorMessage')">
  <div class="inventory-reorder-header">
    <h4 v-t="'Title'"></h4>
  </div>
  <div class="inventory-reorder-container">
    <div class="description">
      <p v-if="displayState === displayStateEnum.NoPointsSet">
        {{$t('NoReorderPoints')}}
          <help-center-link v-if="!isPoweredBySubAccountUser" link-key="dashboard/reorderPoint">
            {{ $t('NoReorderPointsLink') }}
          </help-center-link>
      </p>
      <p v-if="displayState === displayStateEnum.SomePointsBelow">
        {{$t('BelowPoint')}}
      </p>
      <p v-if="displayState === displayStateEnum.AllPointsAbove">
        {{$t('AbovePoint')}}
      </p>
    </div>
    <div class="actions">
      <sb-button v-if="displayState === displayStateEnum.NoPointsSet"
        variation="primary"
        :id="'set-now'"
        :color="'blue'"
        @click="viewPage(routeProducts)"
          >
      {{$t('SetNow')}}
      </sb-button>
      <sb-button v-if="displayState === displayStateEnum.SomePointsBelow"
        variation="primary"
        :id="'view-all-inventory-levels'"
        @click="viewPage(routeInventoryStatus)"
          >
      {{$t('ViewAllLevels')}}
      </sb-button>
      <sb-button v-if="displayState === displayStateEnum.SomePointsBelow"
        variation="primary"
        :id="'send-more-inventory'"
        :color="'blue'"
        @click="routeToSendInventory"
          >
      {{$t('SendMore')}}
      </sb-button>
      <sb-button v-if="displayState === displayStateEnum.AllPointsAbove"
        variation="primary"
        :id="'manage-inventory'"
        :color="'blue'"
        @click="viewPage(routeProducts)"
          >
      {{$t('Manage')}}
      </sb-button>
    </div>
  </div>

  </DashboardPanelTemplate>
</template>

<script>
import DashboardPanelTemplate from '@/components/layouts/DashboardPanelTemplate'
import DisplayStateEnum from '@enums/modules/dashboard/inventoryReorderDisplayState'
import { WarehouseReceivingOrderEnum } from '@/enums/modules/routes'

export default {
  name: 'InventoryReorderPanel',
  inject: ['isPoweredBySubAccountUser'],
  props: {
    panelSize: {
      type: String,
      required: true
    },
    panelFocus: {
      type: Boolean,
      required: false,
      default: false
    },
    loading: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  components: {
    DashboardPanelTemplate
  },
  data () {
    return {
      datastoreLocation: 'dashboard/inventoryReorder/',
      initialRequestLoading: true,
      displayStateEnum: DisplayStateEnum,
      routeProducts: '/App/IndexV2/#/Products',
      routeInventoryStatus: '/App/IndexV2/#/InventoryStatusV2',
      routeSendInventory: '/ShipBobInventory/InputV2#/sendInventory/step1'
    }
  },
  computed: {
    loadingError () {
      return this.$shipBobStore.getters[this.datastoreLocation + 'loadingError']
    },
    inventoryReorderModel () {
      return this.$shipBobStore.getters[this.datastoreLocation + 'inventoryReorderModel']
    },
    displayState () {
      return this.inventoryReorderModel.DisplayState
    }
  },
  async created () {
    await this.$shipBobStore.dispatch(this.datastoreLocation + 'getReorderState')
    this.initialRequestLoading = false
  },
  destroyed () {
    this.$shipBobStore.unregisterModule(['dashboard', 'inventoryReorder'])
  },
  methods: {
    routeToSendInventory () {
      // eslint-disable-next-line dot-notation
      if (this.$shipBobStore.getters['enableCreateWroUiFeatureFlag']) {
        this.$router.push({ name: WarehouseReceivingOrderEnum.ChooseWarehouseReceivingOrderType })
      } else {
        window.location = '/ShipBobInventory/InputV2'
      }
    },
    viewPage (route) {
      window.location = this.$sbAppSettings.photoPrint(route)
    }
  },
  i18n: {
    messages: {
      'en-US': {
        Title: 'Your Inventory',
        NoReorderPoints: 'You haven\'t set any reorder points yet! ',
        NoReorderPointsLink: 'Follow this helpful guide to learn how to set reorder points by product and fulfillment center',
        BelowPoint: 'You have items below your designated Reorder points! Take action now to ensure you don\'t run out of stock',
        AbovePoint: 'All of your items are above their designated reorder points. Keep up the good work!',
        SetNow: 'Set Reorder Points Now',
        ViewAllLevels: 'View All Inventory Levels',
        SendMore: 'Send More Inventory',
        Manage: 'Manage Inventory',
        ErrorMessage: 'Hm... we couldn\'t load your content. Please refresh your browser and if you have issues, let our support team know.'
      }
    }
  }
}
</script>

<style scoped lang="scss">
  @import '@/../assets/scss/shipbob-custom/components/dashboard/_panel-inventory-reorder.scss'
</style>
